type BadgeNavigator = Navigator & {
  setAppBadge?: (contents?: number) => Promise<void>;
  clearAppBadge?: () => Promise<void>;
};

export function updateAppBadge(unreadCount: number): void {
  if (typeof navigator === "undefined") return;
  const badgeNavigator = navigator as BadgeNavigator;
  if (unreadCount > 0 && badgeNavigator.setAppBadge) {
    void Promise.resolve(badgeNavigator.setAppBadge(unreadCount)).catch(
      () => undefined
    );
  } else if (unreadCount === 0 && badgeNavigator.clearAppBadge) {
    void Promise.resolve(badgeNavigator.clearAppBadge()).catch(() => undefined);
  }
}
